export function getLazyLoadableLangFiles(languageCode: string) {
  const localeModules = import.meta.glob('./lang/*.json');
  const lazyLoadLocaleFile =
    localeModules[`./lang/${languageCode.toLowerCase()}.json`];

  return lazyLoadLocaleFile;
}
